import { render, staticRenderFns } from "./Splashscreen.vue?vue&type=template&id=44aab572&scoped=true&"
import script from "./Splashscreen.vue?vue&type=script&lang=js&"
export * from "./Splashscreen.vue?vue&type=script&lang=js&"
import style0 from "./Splashscreen.vue?vue&type=style&index=0&id=44aab572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aab572",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Splashscreen.vue
// module id = null
// module chunks = 